/** Approximate [longitude, latitude] centroids for ISO 3166-1 alpha-2 codes. */
export const COUNTRY_COORDINATES = {
    US: [-98.5795, 39.8283],
    CA: [-106.3468, 56.1304],
    MX: [-102.5528, 23.6345],
    GB: [-3.436, 55.3781],
    IE: [-8.2439, 53.4129],
    FR: [2.2137, 46.2276],
    DE: [10.4515, 51.1657],
    NL: [5.2913, 52.1326],
    BE: [4.4699, 50.5039],
    ES: [-3.7492, 40.4637],
    IT: [12.5674, 41.8719],
    PT: [-8.2245, 39.3999],
    SE: [18.6435, 60.1282],
    NO: [8.4689, 60.472],
    FI: [25.7482, 61.9241],
    PL: [19.1451, 51.9194],
    CH: [8.2275, 46.8182],
    AT: [14.5501, 47.5162],
    AU: [133.7751, -25.2744],
    NZ: [174.886, -40.9006],
    JP: [138.2529, 36.2048],
    KR: [127.7669, 35.9078],
    CN: [104.1954, 35.8617],
    IN: [78.9629, 20.5937],
    SG: [103.8198, 1.3521],
    BR: [-51.9253, -14.235],
    AR: [-63.6167, -38.4161],
    CL: [-71.543, -35.6751],
    ZA: [22.9375, -30.5595],
    AE: [53.8478, 23.4241],
    IL: [34.8516, 31.0461],
    TR: [35.2433, 38.9637],
    LU: [6.1296, 49.8153],
    HK: [114.1694, 22.3193],
    RU: [105.3188, 61.524],
};

export function coordinatesForCountry(code) {
    const c = String(code || "").toUpperCase();
    return COUNTRY_COORDINATES[c] || null;
}
